import { PortfolioThunkGenerator } from 'utility/redux/thunkGenerator';

const cycleTimesPerformanceByTrialHttpRequest = (() => {
  const apiName = 'cycleTimesPerformanceByTrial';
  const generatedHttpThunk = new PortfolioThunkGenerator(apiName);
  generatedHttpThunk.resource = `portfolio-health/cycle-by-cycle-details`;
  return generatedHttpThunk.generateThunk();
})();

export default cycleTimesPerformanceByTrialHttpRequest;
